export default __webpack_public_path__ + "static/logo-cbe00dea32cce1d0d4f6b52912dfd67e.png";